import { Component, OnInit } from '@angular/core';
import { applicationFeatures } from '@carm/shared/constants/const-application-features';
import { Breadcrumbs } from '@carm/shared/constants/const-bread-crumbs';
import { ApplicationFeatureName } from '@carm/_utils/models';

@Component({
  selector: 'carm-home-page-view',
  templateUrl: './home-page-view.component.html',
  styleUrls: ['./home-page-view.component.scss'],
})
export class HomePageViewComponent implements OnInit {

  indexPage = applicationFeatures.get(ApplicationFeatureName.HOMEPAGE);

  levels = Breadcrumbs.CBSAHome;

  constructor() { }

  ngOnInit() {
  }

}
